import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Navbar from "../Components/Navbar/navbar";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  updateDoc,
} from "firebase/firestore";
import { db } from "../Config/firebase";
import { COLLECTION_FAIXAS_DNIT, faixasDnitPadrao } from "./compactacaoModel";
import { consultaTenantAtual , aplicarTenantAtual} from "../Utils/tenant";

const letras = ["A", "B", "C", "D", "E", "F"];

function normalizar(valor) {
  return String(valor || "").toLowerCase();
}

export default function CadastroTabelaFaixasDnit() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const [lista, setLista] = useState([]);
  const [filtro, setFiltro] = useState("");

  useEffect(() => {
    carregar();
  }, []);

  async function carregar() {
    const snap = await getDocs(
      consultaTenantAtual(query(collection(db, COLLECTION_FAIXAS_DNIT), orderBy("ordem", "asc")))
    );

    const cadastradas = snap.docs.map((item) => ({ id: item.id, ...item.data() }));
    setLista(cadastradas.length ? cadastradas : faixasDnitPadrao);
  }

  function alterarLinha(index, letra, campo, valor) {
    setLista((atual) =>
      atual.map((item, i) =>
        i === index
          ? { ...item, [letra]: { ...(item[letra] || {}), [campo]: valor } }
          : item
      )
    );
  }

  async function salvarTodos() {
    for (const item of lista) {
      const dados = {
        ordem: Number(item.ordem || 0),
        peneira: item.peneira || "",
        mm: item.mm || "",
        A: item.A || {},
        B: item.B || {},
        C: item.C || {},
        D: item.D || {},
        E: item.E || {},
        F: item.F || {},
        tolerancia: item.tolerancia || "",
        atualizadoEm: new Date(),
      };

      if (item.id) {
        await updateDoc(doc(db, COLLECTION_FAIXAS_DNIT, item.id), dados);
      } else {
        await addDoc(collection(db, COLLECTION_FAIXAS_DNIT), aplicarTenantAtual({
          ...dados,
          criadoEm: new Date(),
        }));
      }
    }

    await carregar();
  }

  const filtrados = useMemo(() => {
    const termo = normalizar(filtro);
    if (!termo) return lista;
    return lista.filter((item) => contemTextoPesquisa(normalizar(item.peneira), termo));
  }, [filtro, lista]);

  return (
    <>
      <Navbar />

      <Box sx={{ mt: "10px", textAlign: "center" }}>
        <Typography variant="h6" fontWeight={700}>
          FAIXAS DNIT
        </Typography>
        <Typography variant="body2">
          Faixa para base estabilizada por peneira
        </Typography>
      </Box>

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2} mb={2}>
          <Button variant="contained" color="success" onClick={() => executarSalvamento(salvarTodos)} disabled={salvandoCadastro}>
            {salvandoCadastro ? "Salvando..." : "Salvar Alterações"}
          </Button>

          <TextField
            size="small"
            label="Pesquisar peneira"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            sx={{ flex: 1 }}
          />
        </Stack>

        <Paper sx={{ overflow: "auto", border: "1px solid #d7dde8", boxShadow: "none" }}>
          <Table size="small" sx={{ minWidth: 980 }}>
            <TableHead sx={{ backgroundColor: "#f1f5f9" }}>
              <TableRow>
                <TableCell rowSpan={2} align="center"><strong>Peneira</strong></TableCell>
                <TableCell rowSpan={2} align="center"><strong>mm</strong></TableCell>
                {letras.map((letra) => (
                  <TableCell key={letra} colSpan={2} align="center"><strong>{letra}</strong></TableCell>
                ))}
                <TableCell rowSpan={2} align="center"><strong>Tolerância</strong></TableCell>
                <TableCell rowSpan={2} align="center"><strong>Histórico</strong></TableCell>
              </TableRow>
              <TableRow>
                {letras.flatMap((letra) => [
                  <TableCell key={`${letra}-min`} align="center">Min</TableCell>,
                  <TableCell key={`${letra}-max`} align="center">Max</TableCell>,
                ])}
              </TableRow>
            </TableHead>

            <TableBody>
              {filtrados.map((item) => {
                const indexReal = lista.findIndex((x) => x.peneira === item.peneira);

                return (
                  <TableRow key={item.id || item.peneira} hover>
                    <TableCell align="center" sx={{ fontWeight: 700 }}>{item.peneira}</TableCell>
                    <TableCell align="center">{item.mm || ""}</TableCell>
                    {letras.flatMap((letra) => [
                      <TableCell key={`${letra}-min`} align="center">
                        <TextField size="small" value={item[letra]?.min || ""} onChange={(e) => alterarLinha(indexReal, letra, "min", e.target.value)} inputProps={{ style: { textAlign: "center" } }} />
                      </TableCell>,
                      <TableCell key={`${letra}-max`} align="center">
                        <TextField size="small" value={item[letra]?.max || ""} onChange={(e) => alterarLinha(indexReal, letra, "max", e.target.value)} inputProps={{ style: { textAlign: "center" } }} />
                      </TableCell>,
                    ])}
                    <TableCell align="center">{item.tolerancia || ""}</TableCell>
                    <TableCell align="center">
                      <HistoricoCadastro colecao={COLLECTION_FAIXAS_DNIT} documentoId={item.id} registro={item} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </>
  );
}
